import { makeResource, mapped } from '@codium/codium-vue'
import { http } from '@/utils'
import { storeModule as screens } from '../integrations/screens'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('settings/integrations', {
  namespaced: true,
  storeModule: {
    modules: {
      screens
    },

    actions: {
      async restoreIntegration ({ getters }, item) {
        await http.put(`${getters.uri()}/${item.id}/restore`, item)
      }
    },
  },
  resource () {
    return {
      id: null,
      name: mapped(null),
      trigger: mapped([]),
      screens: mapped(null),
      url: mapped(null),
      token: mapped(null),
      archived: null
    }
  }
})
